
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/content-brief",
      function () {
        return require("private-next-pages/app/tools/content-brief.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/content-brief"])
      });
    }
  